import { render, staticRenderFns } from "./bc-options-input.vue?vue&type=template&id=ebf9a7c4"
import script from "./bc-options-input.vue?vue&type=script&lang=js"
export * from "./bc-options-input.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports